import { OrdersService } from "./../../modules/orders/orders.service";
import { PageService } from "app/services/page-service";
import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { GlobalService } from "app/services/global.service";

@Component({
  selector: "app-riders-list",
  templateUrl: "./riders-list.component.html",
  styles: [],
})
export class RidersListComponent implements OnInit {
  @Input() data: any;
  loader = false;
  ridersList: any = [];
  riderSelected = false;
  orderId = "";
  riderId = "";
  coordinates = [85.8380278, 20.2620163];
  address = "";
  status = "";
  private geoCoder: any;
  zoom!: number;

  constructor(
    public dialogRef: NgbActiveModal,
    public pageService: PageService,
    public global: GlobalService,
    public orderService: OrdersService
  ) {}

  ngOnInit(): void {
    this.getRiders();
    this.orderId = this.data["orderId"];
    if (this.orderId) {
      this.getOrderDetails();
    }
  }

  getRiders() {
    const search = { status: "ACCEPTING" };
    if(this.data.type){
      search['type'] = this.data.type;
      // if(search['type'] === 'service'){
      search['orderID'] = this.data.orderId;
      // }
    }
    console.log(search)
    this.loader = true;
    this.pageService
      .postMethod(`deliveryPartner/getRiderList`, search)
      .then((data) => {
        this.loader = false;
        this.ridersList = data["data"];
        this.ridersList.forEach((rider: any) => {
          if (rider["location"]) {
            const lat = rider["location"]["coordinates"][1];
            const lng = rider["location"]["coordinates"][0];
            this.pageService
              .getMapAddress(lat, lng)
              .then((data) => {
                this.address =
                  data["results"] &&
                  data["results"][0] &&
                  data["results"][0]["formatted_address"]
                    ? data["results"][0]["formatted_address"]
                    : "NA";
                rider["address"] = this.address;
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            rider["address"] = "NA";
          }
        });
      })
      .catch((err) => {
        this.loader = false;
        this.global.failureErrorModal(err);
      });
  }

  close() {
    this.dialogRef.close({ success: false });
  }

  selectedRider(data: any, index: any) {
    this.riderSelected = true;
    this.riderId =
      data["deliveryPartnerID"][0] && data["deliveryPartnerID"][0]["_id"]
        ? data["deliveryPartnerID"][0]["_id"]
        : "";
  }

  getOrderDetails() {
    this.orderService
      .getOrderDetails(this.orderId)
      .then((data) => {
        this.status = data["orderDetails"]["status"];
      })
      .catch((err) => {
        this.global.failureErrorModal(err);
      });
  }

  assignRider() {
    this.loader = true;
    const reassignData = {
      orderID: this.orderId,
      riderID: this.riderId,
    };

    if (this.status === "DELIVERED") {
      this.global.failureErrorModal("This order has already been delivered!!");
      setTimeout(() => {
        this.close();
      }, 2000);
      return;
    } else {
      this.pageService
        .postMethod(`deliveryPartner/manualAssign`, reassignData)
        .then((response) => {
          this.loader = false;
          console.log(response);
          this.dialogRef.close({ success: true });
        })
        .catch((err) => {
          this.loader = false;
          this.global.failureErrorModal(err);
          this.dialogRef.close({ success: false });
        });
    }
  }
}
